(function () {
  function shuffle(items) {
    const array = items.slice();

    for (let i = array.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }

    return array;
  }

  function encodeImageBase(baseUrl) {
    const match = baseUrl.match(/^(https?:\/\/[^/]+)(\/.*)?$/i);
    if (!match) {
      return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    }

    const origin = match[1];
    const rawPath = match[2] || '/';
    const encodedPath = rawPath
      .split('/')
      .map((segment) => (segment ? encodeURIComponent(segment) : ''))
      .join('/');

    return `${origin}${encodedPath}${encodedPath.endsWith('/') ? '' : '/'}`;
  }

  function buildImageSrc(baseUrl, filename) {
    return encodeImageBase(baseUrl) + encodeURIComponent(filename);
  }

  function isLocalDev() {
    return ['127.0.0.1', 'localhost'].includes(window.location.hostname);
  }

  async function fetchApiImages(apiUrl) {
    if (!apiUrl) {
      return [];
    }

    try {
      const apiResponse = await fetch(apiUrl, {
        headers: { Accept: 'application/json' },
      });

      if (!apiResponse.ok) {
        return [];
      }

      const apiImages = await apiResponse.json();
      if (!Array.isArray(apiImages)) {
        return [];
      }

      const seen = new Set();

      return apiImages
        .filter((image) => image?.src)
        .map((image) => ({
          src: image.src,
          fallbackSrc: '',
          alt: image.alt || 'Portfolio Skate Style',
        }))
        .filter((image) => {
          if (seen.has(image.src)) {
            return false;
          }

          seen.add(image.src);
          return true;
        });
    } catch {
      return [];
    }
  }

  async function loadImages(root) {
    const manifestUrl = root.dataset.manifestUrl;
    const configuredBase = root.dataset.imageBase;
    const apiUrl = root.dataset.apiUrl;
    const localBase = root.dataset.localImageBase || 'http://localhost:8000/images/photosite/';

    const apiImages = await fetchApiImages(apiUrl);
    if (apiImages.length > 0) {
      return shuffle(apiImages);
    }

    if (!manifestUrl || !configuredBase) {
      return [];
    }

    try {
      const response = await fetch(manifestUrl, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const files = await response.json();

      if (!Array.isArray(files) || files.length === 0) {
        return [];
      }

      const primaryBase = isLocalDev() ? localBase : configuredBase;
      const fallbackBase = isLocalDev() ? configuredBase : localBase;
      const seen = new Set();

      return shuffle(
        files
          .filter((filename) => typeof filename === 'string' && filename.length > 0)
          .map((filename) => {
            const candidates = [buildImageSrc(primaryBase, filename)];

            if (fallbackBase !== primaryBase) {
              candidates.push(buildImageSrc(fallbackBase, filename));
            }

            return {
              src: candidates[0],
              fallbackSrc: candidates[1] || '',
              alt: 'Portfolio Skate Style',
            };
          })
          .filter((image) => {
            if (seen.has(image.src)) {
              return false;
            }

            seen.add(image.src);
            return true;
          }),
      );
    } catch {
      return [];
    }
  }

  async function initPortfolio(root) {
    const grid = root.querySelector('[data-ss-portfolio-grid]');
    const button = root.querySelector('[data-ss-portfolio-more]');
    const status = root.querySelector('[data-ss-portfolio-status]');

    if (!grid || !button) {
      return;
    }

    // Ignore stale async runs if init is called again while loading
    // (script loaded twice / theme editor section:load race).
    const runId = (Number(root.dataset.ssPortfolioRun) || 0) + 1;
    root.dataset.ssPortfolioRun = String(runId);

    const isStale = () => root.dataset.ssPortfolioRun !== String(runId);

    grid.replaceChildren();
    button.hidden = true;
    button.onclick = null;

    if (status) {
      status.hidden = false;
      status.textContent = 'Chargement du portfolio…';
    }

    const images = await loadImages(root);

    if (isStale()) {
      return;
    }

    if (status) {
      status.hidden = true;
    }

    grid.replaceChildren();

    if (!images.length) {
      if (status) {
        status.hidden = false;
        status.textContent = 'Aucune image disponible pour le moment.';
      }
      return;
    }

    const perPage = Math.max(1, parseInt(root.dataset.perPage || '12', 10));
    let shown = 0;
    let visibleCount = 0;

    function updateButton() {
      button.hidden = shown >= images.length;
    }

    function removeBrokenItem(item) {
      item.remove();
      visibleCount = Math.max(0, visibleCount - 1);

      if (visibleCount === 0 && shown >= images.length && status) {
        status.hidden = false;
        status.textContent = 'Aucune image disponible pour le moment.';
      }

      updateButton();
    }

    function bindImageFallback(img, item, fallbackSrc) {
      const candidates = [img.src, fallbackSrc].filter(Boolean);
      let attempt = 0;

      img.addEventListener('error', () => {
        attempt += 1;

        if (attempt < candidates.length && candidates[attempt]) {
          img.src = candidates[attempt];
          return;
        }

        removeBrokenItem(item);
      });
    }

    function renderNext() {
      if (isStale()) {
        return;
      }

      const batch = images.slice(shown, shown + perPage);

      batch.forEach((image) => {
        const item = document.createElement('div');
        item.className = 'ss-portfolio__item';
        item.setAttribute('role', 'listitem');

        const img = document.createElement('img');
        img.src = image.src;
        img.alt = image.alt || 'Portfolio Skate Style';
        img.loading = 'lazy';
        img.decoding = 'async';

        bindImageFallback(img, item, image.fallbackSrc);

        item.appendChild(img);
        grid.appendChild(item);
        visibleCount += 1;
      });

      shown += batch.length;
      updateButton();
    }

    button.onclick = renderNext;
    renderNext();
  }

  function boot() {
    document.querySelectorAll('[data-ss-portfolio]').forEach((root) => {
      initPortfolio(root);
    });
  }

  if (!window.__ssPortfolioListenersBound) {
    window.__ssPortfolioListenersBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-ss-portfolio]');
      if (section) {
        initPortfolio(section);
      }
    });
  } else if (document.readyState !== 'loading') {
    boot();
  }
})();
